import { Dropdown, Icon, Menu } from "antd";
import React from "react";
import { Link } from "react-router-dom";
const { SubMenu } = Menu;
export function RenderMenu({
  mode,profile, auth,
}) {
  if (profile.role == 'ADMIN') {
    return <Menu theme="dark" mode={mode}>
      <SubMenu  key="dashboard" title={<>

        <Icon type="dashboard" /> Dashboards  <Icon type="down" />
      </>}>
        <Menu.Item key="dashboard">
          <Link to="/home/campusDashboard/ADMIN">
            Society Dashboard
                      </Link>
        </Menu.Item>

        <SubMenu style={{
          width: 180
        }} key="campusDashboard" title={<>
          <span>Campus Dashboards</span>
        </>}>
          <Menu.Item key="BVRIT">
            <Link to="/home/campusDashboard/BVRIT">BVRIT</Link>
          </Menu.Item>
          <Menu.Item key="BVRITH">
            <Link to="/home/campusDashboard/BVRITH">BVRITH</Link>
          </Menu.Item>
          <Menu.Item key="SVCEW">
            <Link to="/home/campusDashboard/SVECW">SVECW</Link>
          </Menu.Item>
          <Menu.Item key="VIT">
            <Link to="/home/campusDashboard/VIT">VIT</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu style={{
          width: 180
        }} key="AssessmentDashboard" title={<>
          <span>Assessment Dashboards</span>
        </>}>
          <Menu.Item key="Skill">
            <Link to="/home/skills">Skill Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="Workshop">
            <Link to="/home/workshops">Workshop Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Internship">
            <Link to="/home/internships">Internship Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Projects">
            <Link to="/home/projectsDashboard">Project Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Conference">
            <Link to="/home/conferences">Conference Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Publication">
            <Link to="/home/publications">Publication Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Certification">
            <Link to="/home/certifications">Certification Dashboard</Link>
          </Menu.Item>
        </SubMenu>
      </SubMenu>

      <SubMenu key="sub3" title={<>
        <Icon type="appstore" />{" "}
        <span>Competitive Programming </span>
        
        <Icon type="down" />
      </>}>
        <Menu.Item key="CPDashboard">
          <Link to="/home/cpDashboard">Overall Leaderboard</Link>
        </Menu.Item>

      </SubMenu>

      <Menu.Item key="project">
        <Link to="/home/projects">
          {" "}
          <Icon type="project" />
          Projects{" "}
        </Link>
      </Menu.Item>

      <SubMenu key="TeamsCp" title={<>
        <Icon type="team" /> <span>Teams</span>
      </>}>
        <Menu.Item key="CPTeamsView">
          <Link to="/home/CPTeamsView">
            {" "}
            View Teams
                    </Link>
        </Menu.Item>
        <Menu.Item key="CPTeams">
          <Link to="/home/CPTeams">
            {" "}

            Create New Team
                    </Link>
        </Menu.Item>
      </SubMenu>

      <SubMenu key="sub5" title={<>
        <Icon type="user" /> <span>Admin</span> <Icon type="down" />
      </>}>
        <Menu.Item key="addAdmin">
          <Link to="/home/addAdmin">Add Admin</Link>
        </Menu.Item>
        <Menu.Item key="addPrincipal">
          <Link to="/home/addPrincipal">Add Principal</Link>
        </Menu.Item>
        <Menu.Item key="addHOD">
          <Link to="/home/addHOD">Add HOD</Link>
        </Menu.Item>

        <Menu.Item key="addFaculty">
          <Link to="/home/addFaculty">Add Faculty</Link>
        </Menu.Item>

        <Menu.Item key="addStudent">
          <Link to="/home/addStudent">Add Student</Link>
        </Menu.Item>

      </SubMenu>
    </Menu>;
  }
  else if (profile.role == 'STUDENT') {
    return <Menu theme="dark" mode={mode} >
      <SubMenu key="dashboard" title={<>

        <Icon type="dashboard" /> Dashboards  <Icon type="down" />
      </>}>
        <Menu.Item key="dashboard">
          <Link to="/home/campusDashboard/ADMIN">
            Society Dashboard
                          </Link>
        </Menu.Item>

        <SubMenu style={{
          width: 180
        }} key="campusDashboard" title={<>
          <span>Campus Dashboards</span>
        </>}>
          <Menu.Item key="BVRIT">
            <Link to="/home/campusDashboard/BVRIT">BVRIT</Link>
          </Menu.Item>
          <Menu.Item key="BVRITH">
            <Link to="/home/campusDashboard/BVRITH">BVRITH</Link>
          </Menu.Item>
          <Menu.Item key="SVCEW">
            <Link to="/home/campusDashboard/SVECW">SVECW</Link>
          </Menu.Item>
          <Menu.Item key="VIT">
            <Link to="/home/campusDashboard/VIT">VIT</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu style={{
          width: 180
        }} key="AssessmentDashboard" title={<>
          <span>Assessment Dashboards</span>
        </>}>
          <Menu.Item key="Skill">
            <Link to="/home/skills">Skill Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="Workshop">
            <Link to="/home/workshops">Workshop Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Internship">
            <Link to="/home/internships">Internship Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Projects">
            <Link to="/home/projectsDashboard">Project Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Conference">
            <Link to="/home/conferences">Conference Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Publication">
            <Link to="/home/publications">Publication Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Certification">
            <Link to="/home/certifications">Certification Dashboard</Link>
          </Menu.Item>
        </SubMenu>
      </SubMenu>
      <Menu.Item key="profile">
        <Link to={`/home/profile/${auth.uid ? auth.uid : "/"}`}>
          <Icon type="profile" /> Profile
                        </Link>
      </Menu.Item>

      <SubMenu key="sub3" title={<>
        <Icon type="appstore" />{" "}
        <span>Competitive Programming </span>
        <Icon type="down" />
      </>}>
        <Menu.Item key="CPDashboard">
          <Link to="/home/cpDashboard">Overall Leaderboard</Link>
        </Menu.Item>

      </SubMenu>

      <Menu.Item key="project">
        <Link to="/home/projects">
          {" "}
          <Icon type="project" />
          Projects{" "}
        </Link>
      </Menu.Item>

      <SubMenu key="TeamsCp" title={<>
        <Icon type="team" /> <span>Teams</span>
      </>}>
        <Menu.Item key="CPTeamsView">
          <Link to="/home/CPTeamsView">
            {" "}
            View Teams
                        </Link>
        </Menu.Item>
      </SubMenu>

    </Menu>;
  }
  else if (profile.role == 'FACULTY') {
    return <Menu theme="dark" mode={mode} >
      <SubMenu key="dashboard" title={<>

        <Icon type="dashboard" /> Dashboards  <Icon type="down" />
      </>}>
        <Menu.Item key="dashboard">
          <Link to="/home/campusDashboard/ADMIN">
            Society Dashboard
                      </Link>
        </Menu.Item>

        <SubMenu style={{
          width: 180
        }} key="campusDashboard" title={<>
          <span>Campus Dashboards</span>
        </>}>
          <Menu.Item key="BVRIT">
            <Link to="/home/campusDashboard/BVRIT">BVRIT</Link>
          </Menu.Item>
          <Menu.Item key="BVRITH">
            <Link to="/home/campusDashboard/BVRITH">BVRITH</Link>
          </Menu.Item>
          <Menu.Item key="SVCEW">
            <Link to="/home/campusDashboard/SVECW">SVECW</Link>
          </Menu.Item>
          <Menu.Item key="VIT">
            <Link to="/home/campusDashboard/VIT">VIT</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu style={{
          width: 180
        }} key="AssessmentDashboard" title={<>
          <span>Assessment Dashboards</span>
        </>}>
          <Menu.Item key="Skill">
            <Link to="/home/skills">Skill Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="Workshop">
            <Link to="/home/workshops">Workshop Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Internship">
            <Link to="/home/internships">Internship Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Projects">
            <Link to="/home/projectsDashboard">Project Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Conference">
            <Link to="/home/conferences">Conference Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Publication">
            <Link to="/home/publications">Publication Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Certification">
            <Link to="/home/certifications">Certification Dashboard</Link>
          </Menu.Item>
        </SubMenu>
      </SubMenu>
      <Menu.Item key="profile">
        <Link to={`/home/profile/${auth.uid ? auth.uid : "/"}`}>
          <Icon type="profile" /> Profile
                    </Link>
      </Menu.Item>

      <SubMenu key="sub3" title={<>
        <Icon type="appstore" />{" "}
        <span>Competitive Programming </span>
        <Icon type="down" />
      </>}>
        <Menu.Item key="CPDashboard">
          <Link to="/home/cpDashboard">Overall Leaderboard</Link>
        </Menu.Item>

      </SubMenu>

      <Menu.Item key="project">
        <Link to="/home/projects">
          {" "}
          <Icon type="project" />
          Projects{" "}
        </Link>
      </Menu.Item>

      <SubMenu key="TeamsCp" title={<>
        <Icon type="team" /> <span>Teams</span>
      </>}>
        <Menu.Item key="CPTeamsView">
          <Link to="/home/CPTeamsView">
            {" "}
            View Teams
                    </Link>
        </Menu.Item>
        <Menu.Item key="CPTeams">
          <Link to="/home/CPTeams">
            {" "}

            Create New Team
                    </Link>
        </Menu.Item>
      </SubMenu>

      <SubMenu key="sub5" title={<>
        <Icon type="user" /> <span>Admin</span><Icon type="down" />
      </>}>

        <Menu.Item key="addStudent">
          <Link to="/home/addStudent">Add Student</Link>
        </Menu.Item>

      </SubMenu>
    </Menu>;
  }
  else if (profile.role == 'HOD') {
    return <Menu theme="dark" mode={mode} >
      <SubMenu key="dashboard" title={<>

        <Icon type="dashboard" /> Dashboards  <Icon type="down" />
      </>}>
        <Menu.Item key="dashboard">
          <Link to="/home/campusDashboard/ADMIN">
            Society Dashboard
                      </Link>
        </Menu.Item>

        <SubMenu style={{
          width: 180
        }} key="campusDashboard" title={<>
          <span>Campus Dashboards</span>
        </>}>
          <Menu.Item key="BVRIT">
            <Link to="/home/campusDashboard/BVRIT">BVRIT</Link>
          </Menu.Item>
          <Menu.Item key="BVRITH">
            <Link to="/home/campusDashboard/BVRITH">BVRITH</Link>
          </Menu.Item>
          <Menu.Item key="SVCEW">
            <Link to="/home/campusDashboard/SVECW">SVECW</Link>
          </Menu.Item>
          <Menu.Item key="VIT">
            <Link to="/home/campusDashboard/VIT">VIT</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu style={{
          width: 180
        }} key="AssessmentDashboard" title={<>
          <span>Assessment Dashboards</span>
        </>}>
          <Menu.Item key="Skill">
            <Link to="/home/skills">Skill Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="Workshop">
            <Link to="/home/workshops">Workshop Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Internship">
            <Link to="/home/internships">Internship Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Projects">
            <Link to="/home/projectsDashboard">Project Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Conference">
            <Link to="/home/conferences">Conference Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Publication">
            <Link to="/home/publications">Publication Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Certification">
            <Link to="/home/certifications">Certification Dashboard</Link>
          </Menu.Item>
        </SubMenu>
      </SubMenu>
      <Menu.Item key="profile">
        <Link to={`/home/profile/${auth.uid ? auth.uid : "/"}`}>
          <Icon type="profile" /> Profile
                    </Link>
      </Menu.Item>

      <SubMenu key="sub3" title={<>
        <Icon type="appstore" />{" "}
        <span>Competitive Programming </span>
        <Icon type="down" />
      </>}>
        <Menu.Item key="CPDashboard">
          <Link to="/home/cpDashboard">Overall Leaderboard</Link>
        </Menu.Item>

      </SubMenu>

      <Menu.Item key="project">
        <Link to="/home/projects">
          {" "}
          <Icon type="project" />
          Projects{" "}
        </Link>
      </Menu.Item>

      <SubMenu key="TeamsCp" title={<>
        <Icon type="team" /> <span>Teams</span>
      </>}>
        <Menu.Item key="CPTeamsView">
          <Link to="/home/CPTeamsView">
            {" "}
            View Teams
                    </Link>
        </Menu.Item>
        <Menu.Item key="CPTeams">
          <Link to="/home/CPTeams">
            {" "}

            Create New Team
                    </Link>
        </Menu.Item>
      </SubMenu>

      <SubMenu key="sub5" title={<>
        <Icon type="user" /> <span>Admin</span> <Icon type="down" />
      </>}>

        <Menu.Item key="addFaculty">
          <Link to="/home/addFaculty">Add Faculty</Link>
        </Menu.Item>

        <Menu.Item key="addStudent">
          <Link to="/home/addStudent">Add Student</Link>
        </Menu.Item>

      </SubMenu>
    </Menu>;
  }
  else if (profile.role == 'PRINCIPAL') {
    return <Menu theme="dark" mode={mode} >
      <SubMenu key="dashboard" title={<>

        <Icon type="dashboard" /> Dashboards  <Icon type="down" />
      </>}>
        <Menu.Item key="dashboard">
          <Link to="/home/campusDashboard/ADMIN">
            Society Dashboard
                      </Link>
        </Menu.Item>

        <SubMenu style={{
          width: 180
        }} key="campusDashboard" title={<>
          <span>Campus Dashboards</span>
        </>}>
          <Menu.Item key="BVRIT">
            <Link to="/home/campusDashboard/BVRIT">BVRIT</Link>
          </Menu.Item>
          <Menu.Item key="BVRITH">
            <Link to="/home/campusDashboard/BVRITH">BVRITH</Link>
          </Menu.Item>
          <Menu.Item key="SVCEW">
            <Link to="/home/campusDashboard/SVECW">SVECW</Link>
          </Menu.Item>
          <Menu.Item key="VIT">
            <Link to="/home/campusDashboard/VIT">VIT</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu style={{
          width: 180
        }} key="AssessmentDashboard" title={<>
          <span>Assessment Dashboards</span>
        </>}>
          <Menu.Item key="Skill">
            <Link to="/home/skills">Skill Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="Workshop">
            <Link to="/home/workshops">Workshop Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Internship">
            <Link to="/home/internships">Internship Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Projects">
            <Link to="/home/projectsDashboard">Project Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Conference">
            <Link to="/home/conferences">Conference Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Publication">
            <Link to="/home/publications">Publication Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="Certification">
            <Link to="/home/certifications">Certification Dashboard</Link>
          </Menu.Item>
        </SubMenu>
      </SubMenu>
      <Menu.Item key="profile">
        <Link to={`/home/profile/${auth.uid ? auth.uid : "/"}`}>
          <Icon type="profile" /> Profile
                    </Link>
      </Menu.Item>

      <SubMenu key="sub3" title={<>
        <Icon type="appstore" />{" "}
        <span>Competitive Programming </span>
        <Icon type="down" />
      </>}>
        <Menu.Item key="CPDashboard">
          <Link to="/home/cpDashboard">Overall Leaderboard</Link>
        </Menu.Item>

      </SubMenu>

      <Menu.Item key="project">
        <Link to="/home/projects">
          {" "}
          <Icon type="project" />
          Projects{" "}
        </Link>
      </Menu.Item>

      <SubMenu key="TeamsCp" title={<>
        <Icon type="team" /> <span>Teams</span>
      </>}>
        <Menu.Item key="CPTeamsView">
          <Link to="/home/CPTeamsView">
            {" "}
            View Teams
                    </Link>
        </Menu.Item>
        <Menu.Item key="CPTeams">
          <Link to="/home/CPTeams">
            {" "}

            Create New Team
                    </Link>
        </Menu.Item>
      </SubMenu>

      <SubMenu key="sub5" title={<>
        <Icon type="user" /> <span>Admin</span> <Icon type="down" />
      </>}>
        <Menu.Item key="addHOD">
          <Link to="/home/addHOD">Add HOD</Link>
        </Menu.Item>

        <Menu.Item key="addFaculty">
          <Link to="/home/addFaculty">Add Faculty</Link>
        </Menu.Item>

        <Menu.Item key="addStudent">
          <Link to="/home/addStudent">Add Student</Link>
        </Menu.Item>

      </SubMenu>
    </Menu>;
  }
}
